module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('span', {
    staticClass: "c-about__basquait"
  }), _vm._v(" "), _c('div', {
    staticClass: "o-section__max-w o-section--pt o-section--about",
    class: {
      'o-section--about--first': _vm.firstLoad
    }
  }, [_c('div', {
    staticClass: "c-about__image-container c-about__image-container--left"
  }, [_c('img', {
    staticClass: "c-about__image c-about__image--left c-about__image--left--dup",
    attrs: {
      "src": _vm.nz
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "c-about__image c-about__image--left c-about__image--left--1",
    attrs: {
      "src": _vm.making
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "js-block js-block--image"
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-about__image-container c-about__image-container--right"
  }, [_c('img', {
    staticClass: "c-about__image c-about__image--right c-about__image--right--dup",
    attrs: {
      "src": _vm.legend
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "c-about__image c-about__image--right c-about__image--right--1",
    attrs: {
      "src": _vm.printing
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "js-block js-block--image"
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-about__text"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "c-about__intro js-anim"
  }, [_vm._v("FOUNDED IN 2018")]), _vm._v(" "), _c('p', {
    staticClass: "c-about__sub-intro js-anim"
  }, [_c('span', {
    staticClass: "js-block js-block--text"
  }), _vm._v(" "), _c('span', {
    staticClass: "js-left-g"
  }, [_vm._v("THE UNINVITED GUEST WHO STAYS 'TILL THE END")]), _vm._v(" "), _c('span', {
    staticClass: "js-left-og"
  }, [_vm._v("\n          TIRED OF SKULLS, BONES AND\n          "), _c('span', {
    staticClass: "c-about__text--highlighted basquiat-hover",
    on: {
      "mouseenter": function($event) {
        _vm.hoverBasquiat()
      },
      "mouseleave": function($event) {
        _vm.leaveBasquiat()
      }
    }
  }, [_vm._v("BASQUIAT")]), _vm._v(" COPY CATS.\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "c-about__aside js-anim"
  }, [_c('span', {
    staticClass: "js-block js-block--text"
  }), _vm._v(" "), _c('span', {
    staticClass: "js-right-g"
  }, [_vm._v("A RENAISSANCE OF CLASSICAL STYLES CREATED WITH MODERN PRECISION AND ACCURACY.")]), _vm._v(" "), _c('span', {
    staticClass: "js-right-og"
  }, [_vm._v("\n          OUR WORKS ARE DESIGNED AND CRAFTED IN\n          "), _c('span', {
    staticClass: "c-about__text--highlighted js-nz",
    on: {
      "mouseenter": function($event) {
        _vm.hoverNZ()
      },
      "mouseleave": function($event) {
        _vm.leaveNZ()
      }
    }
  }, [_vm._v("NEW ZEALAND")]), _vm._v(" USING A COMBINATION OF 3D PRINTING AND TRADITIONAL TECHNIQUES.\n        ")])]), _vm._v(" "), _c('h3', {
    staticClass: "c-about__send-off js-anim",
    on: {
      "mouseenter": function($event) {
        _vm.hoverBottom()
      },
      "mouseleave": function($event) {
        _vm.leaveBottom()
      }
    }
  }, [_vm._v("\n        MADE TO LAST FOR GENERATIONS\n        "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "120px",
      "line-height": "0px"
    }
  }, [_vm._v(".")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "c-about__title js-anim"
  }, [_c('span', {
    staticClass: "c-about__title--cap"
  }, [_vm._v("A")]), _vm._v("RTFUL\n        "), _c('span', {
    staticClass: "c-about__title--cap"
  }, [_vm._v("D")]), _vm._v("ODGERS\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d3ad8e9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 391
// module chunks = 0